import { useMemo } from 'react';

import {
	faBars,
	faBell,
	faBoxes,
	faDolly,
	faPrint,
	faScrewdriverWrench,
	faTruck,
	faUsersCog
} from '@fortawesome/pro-regular-svg-icons';

import useActions from './useActions';

const menuLibrary = [
	{
		label: 'main',
		icon: faBars
	},
	{
		label: 'createShipment',
		icon: faTruck,
		variant: 'blue'
	},
	{
		label: 'order',
		icon: faDolly
	},
	{
		label: 'otoPack',
		icon: faBoxes
	},
	{
		label: 'notify',
		icon: faBell
	},
	{
		label: 'print',
		icon: faPrint
	},
	{
		label: 'tools',
		icon: faScrewdriverWrench
	},
	{
		label: 'roles',
		icon: faUsersCog
	}
];

const useMenus = (page, actionObjectType) => {
	const { getPageActions } = useActions();

	const actions = useMemo(() => {
		if (!page || !actionObjectType) {
			return null;
		}
		return menuLibrary
			.map((menu) => ({
				...menu,
				items: getPageActions(page, menu.label, actionObjectType)
			}))
			.filter((menu) => menu.items.length > 0);
	}, [page, actionObjectType]);

	return actions;
};

export default useMenus;
